
<div class="input-group">
    <input
      type="date"
      class="form-control datepicker-input w-100 ps-2 custom-datepicker-icon"
      placeholder="Select date"
      aria-label="date"
      [(ngModel)]="inputDate" 
      (keydown)="onkeyDown($event)" 
      (change)="onChange($event)"
      (blur)="onBlur($event)"
      data-provide="datepicker"
      [min]="minDate"
      [max]="maxDate"
    />
</div>